import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'
import { GoogleOAuthProvider } from '@react-oauth/google'

// antd
import { ConfigProvider } from 'antd'

import Client from './client.index'

// slices
import usersSlice from './users/users.slice'
import projectsSlice from './projects/projects.slice'
// import tasksSlice from './tasks/tasks.slice'
import tasksSlice from './taskRefactored/tasks.slice'
// import sprintsSlice from './sprints/sprints.slice'
import loginSlice from './login/login.slice'
import notificationsSlice from './notifications/notifications.slice'
import clientsSlice from './clients/clients.slice'
import workSpaceSlice from './workSpace/workSpace.slice'
import jiraSlice from './jira/jira.slice'
import globalSearchSlice from './globalSearch/globalSearch.slice'
import developmentSprintReducer from './projects/developmentSprint.slice'
import homeSlice from './home/home.slice'
import capacitySlice from './reporting/capacity/capacity.slice'
import workloadSlice from './reporting/workload/workload.slice'
import co7Slice from './co7/co7.slice'
import testRunListSlice from './testRun/redux/testRun/testRunList.slice'
import testCaseCommentSlice from './testRun/redux/testCaseComment/testCaseComment.slice'

const RouteContext = () => {
    const redux = configureStore({
        reducer: {
            usersSlice,
            projectsSlice,
            tasksSlice,
            loginSlice,
            notificationsSlice,
            clientsSlice,
            workSpaceSlice,
            jiraSlice,
            globalSearchSlice,
            developmentSprint: developmentSprintReducer,
            homeSlice,
            capacitySlice,
            workloadSlice,
            co7Slice,
            testRunListSlice,
            testCaseCommentSlice,
        },
    })

    const googleClientId = process.env.REACT_APP_SUPPORT_GOOGLE_OAUTH_CLIENT_ID

    return (
        <Provider store={redux}>
            <ConfigProvider
                theme={{
                    components: {
                        Button: {
                            colorBgContainer: '#4F46E5',
                            colorText: '#fff',
                            fontSize: '16px',
                            colorPrimaryHover: '#fff',
                            colorPrimaryActive: '#fff',
                        },
                    },
                    token: {
                        colorPalette: {
                            baseColor: {
                                primary: '#080325',
                                secondary: '#191A38',
                                tertiary: '#4F46E5',
                                quaternary: '#F7F5FF',
                                quinary: '#CFD7DB',
                                senary: '#F6F7F9',
                                white: '#FFFFFF',
                                black: '#000000',
                                error: '#FF3838',
                            },
                            textColor: {
                                primary: '#252525',
                                secondary: '#747474',
                                tertiary: '#DBD9FF',
                                quaternary: '#B9B9B9',
                                quinary: '#E3E3E3',
                                senary: '#9197A3',
                                gray: '#919EAB29',
                                error: '#FF0000',
                            },
                            iconColor: {
                                primary: '#CFD7DB',
                                secondary: '#DADADA',
                                tertiary: '#1B806A',
                                quaternary: '#B71D18',
                            },
                            registrationColor: {
                                primary: '##031C38',
                                secondary: '#F828A6',
                            },
                        },
                        breakPints: {
                            xs: '400',
                            sm: '768',
                            md: '1200',
                            lg: '1536',
                            xl: '1920',
                        },
                        fontSizes: {},
                        fontFamily: "'Nunito Sans', sans-serif",
                    },
                }}
            >
                <BrowserRouter>
                    <GoogleOAuthProvider clientId={googleClientId}>
                        <Client />
                    </GoogleOAuthProvider>
                </BrowserRouter>
            </ConfigProvider>
        </Provider>
    )
}

export default RouteContext
